// Decorative dino — uses the provided SVG asset in /public.
export default function PixelDino({ size = 56, className = "" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/dino.svg`}
      width={size}
      height={size}
      alt="pixel dinosaur"
      className={className}
      style={{ display: "block" }}
      draggable={false}
    />
  );
}
